import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { GridItemAlignment } from './leading';

@Component({
    selector: 'qpx-grid-item-trailing',
    template: `<ng-content />`,
    styleUrl: './trailing.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[style.align-self]': 'align()',
        '[attr.align]': 'null',
    },
})
export class QpxGridItemTrailing {
    public readonly align = input<GridItemAlignment>('center');
}
